const capitalize = (text: string) => `${text.charAt(0).toUpperCase()}${text.slice(1).toLowerCase()}`;

const isUpperCase = (char: string) => /^[A-Z]$/.test(char);

export const camelCase = (str: string, isUpper = false): string => {
  if (!str) {
    return str;
  }
  const strArr = str.split(/[ _-]+/).filter(Boolean);
  if (strArr.length === 1) {
    return str;
  }
  return strArr.map((text, index) => (index === 0 && !isUpper ? text.toLowerCase() : capitalize(text))).join('');
};

export const snakeCase = (str: string): string => {
  if (!str) {
    return str;
  }
  const strArr = [...str];
  if (strArr.length === 1) {
    return str;
  }
  return strArr.map((text) => (isUpperCase(text) ? `_${text.toLowerCase()}` : text)).join('');
};
